import React, { Suspense } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { lazyImport } from "../utils/lazyImport";
import { Container } from "../components/layout/Container";
import { Loader } from "../components/elements/Loader";
import CacheBuster from "react-cache-buster";
import { version } from "../../package.json";
import { isProduction } from "../config/config.json";
import { ReactComponent as UISvg } from "../assets/ui/ui.svg";
import ScrollToTop from "../utils/scrollToTop";

const { Home } = lazyImport(() => import("./Home"), "Home");
const { Profile } = lazyImport(() => import("./Profile"), "Profile");
const { Contact } = lazyImport(() => import("./Contact"), "Contact");
const { Services } = lazyImport(() => import("./Services"), "Services");
const { Content } = lazyImport(() => import("./Content"), "Content");

function App() {
  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction}
      isVerboseMode={false}
      loadingComponent={<Loader />}
    >
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<Loader />}>
          <Container>
            <Switch>
              <Route exact path={`/`} component={Home} />
              <Route exact path={`/profile`} component={Profile} />
              <Route exact path={`/contact`} component={Contact} />
              <Route exact path={`/contact`} component={Contact} />
              <Route exact path={`/contact/:slug`} component={Contact} />
              <Route exact path={`/services`} component={Services} />
              <Route exact path={`/pages/:slug`} component={Content} />
            </Switch>
          </Container>
        </Suspense>
        <UISvg />
      </BrowserRouter>
    </CacheBuster>
  );
}

export default App;
